module.exports = __webpack_public_path__ + "static/media/fisketur.64fe9446.jpg";